import { css } from '@emotion/react';
import { tokens } from '../tokens';
export function headerStyle({ alignCenter, mode }) {
    return css({
        padding: mode === 'decorative'
            ? `38px ${tokens.spacingNew.large} ${tokens.spacingNew.medium}`
            : `${tokens.spacingNew.large} ${tokens.spacingNew.xxlarge} ${tokens.spacingNew.medium}
          ${alignCenter ? tokens.spacingNew.xxlarge : tokens.spacingNew.large}`,
    });
}
export const bodyStaticStyle = css({
    paddingLeft: tokens.spacingNew.large,
    paddingRight: tokens.spacingNew.large,
});
export const footerStaticStyle = css({
    padding: `${tokens.spacingNew.medium} ${tokens.spacingNew.large}
    ${tokens.spacingNew.large} ${tokens.spacingNew.large}`,
});
